<footer>
    <p>
		CSS made pretty thanks to Chieftain Alex<br />
		Special thanks to Kvothe for the unending debugging
	</p>
</footer>

<style>
	footer{
		background-color: rgba(100,100,100,1);
		height:60px;
		width:100%;
		text-align:right;
		bottom: 0;
		position: unset;
	}

	p {
		text-decoration: none;
		font-size: 1em;
		font-family: 'Century Gothic', sans-serif;
		font-weight: 400;
		color: rgb(230,230,200);
		margin-bottom: 0;
		padding-right: 1em;
	}
</style>